import { motion } from 'framer-motion';
import { ChangeEvent, useState } from 'react';
import { Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import logoGov from '../../../assets/logo_govbr.svg';
import logo_sisaf from '../../../assets/logo_sisaf.png';
import ouImg from '../../../assets/ou.jpg';
import Button from '../../../components/Button';
import ContainerBase from '../../../components/ContainerBase';
import Input from '../../../components/InputNew';
import httpClient, { isHttpError } from '../../../services/httpClient';
//import Toast from '../../../components/Toast';
import { swal } from '../../../utils/swal';

const Container = styled.div`
  display: grid;
  grid-template-rows: 7% 30% 18% 45%;
  align-self: center;
  width: 40%;
  height: 84%;
  margin: 0 auto;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 20px;
  opacity: 1;
`;

const IconLogoContainer = styled.div`
  display: grid;
  grid-template-columns: 46% 54%;
  width: 100%;
  align-items: end;
  justify-content: center;

  a {
    display: flex;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.botaoLaranja};
    font-size: 12px;
    margin-left: 2rem;
  }
  img {
    height: 2.5vh;
    max-height: 50px;
    width: auto;
  }
`;

const LogoSistema = styled.div`
  display: flex;
  align-items: end;
  justify-content: center;
  img {
    height: 20vh;
    width: auto;
  }
`;

const TextContainer = styled.div`
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    margin-top: 2rem;
    margin-bottom: 0.2rem;
    font: normal normal bold 1.35rem Rawline;
  }

  span {
    max-width: 70%;
    font: normal normal normal 1.15rem Rawline;
    letter-spacing: 0px;
    color: #333333;
    opacity: 1;
  }
`;

function EsqueciSenha() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    cpf: '',
    email: '',
  });
  //const [showToast, setShowToast] = useState<boolean>(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (name === 'cpf') {
      setFormData((prev) => ({
        ...prev,
        cpf: value.replace(/\D/g, ''),
      }));
    }
  };

  const handleSubmit = async () => {
    try {
      // Enviando a requisição para recuperar a senha
      const response = await httpClient.post(
        `/api/auth/request-password-reset`,
        formData,
      );

      // Se houver uma mensagem de sucesso na resposta
      if (response.data?.message) {
        const email = response.data?.mail || 'Seu e-mail'; // Usar email ou valor padrão

        // Manipulando o e-mail para mostrar apenas as 3 primeiras letras e o domínio
        const [userPart, domainPart] = email.split('@');
        const visibleEmail = `${userPart.slice(0, 3)}...@${domainPart}`;

        // Exibe o sucesso no swal com a mensagem personalizada
        swal(
          'success',
          `Um link de recuperação de senha foi enviado para ${visibleEmail}.`,
          `Por favor, verifique sua caixa de entrada e siga as instruções para redefinir sua senha.`,
        );
      } else if (response.data?.message === 'Usuário não encontrado') {
        // Se a resposta indicar que o usuário não foi encontrado
        swal(
          'error',
          'Tente novamente!',
          'Usuário não encontrado. Tente novamente.',
        );
      } else {
        // Caso não tenha uma mensagem, exibe erro genérico
        swal(
          'error',
          'Tente novamente!',
          'Erro ao enviar o link de recuperação de senha.',
        );
      }
      setTimeout(() => {
        navigate('/');
      }, 10000);
    } catch (error) {
      console.error(error);

      // Verifica se é um erro do Axios
      if (isHttpError(error) && error.response) {
        swal(
          'error',
          'Tente novamente!',
          'Erro ao enviar o link de recuperação de senha.',
        );
      } else {
        // Exibe um erro genérico
        swal(
          'error',
          'Tente novamente!',
          'Erro ao enviar o link de recuperação de senha.',
        );
      }
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      <ContainerBase>
        <Container>
          <IconLogoContainer>
            <a href="/">
              <span className="material-icons">arrow_back</span>
            </a>
            <img src={logoGov} alt="Logo do SisAF" />
          </IconLogoContainer>
          <LogoSistema>
            <img src={logo_sisaf} alt="Logo do SisAF" />
          </LogoSistema>
          <TextContainer>
            <p style={{ color: '#1351B4' }}>Esqueci minha senha</p>
            <span>Informe seu CPF para redefinir sua senha:</span>
          </TextContainer>
          <Stack
            className="gap-2"
            style={{ width: '41%', margin: '18px auto' }}
          >
            <Input
              type={'cpf'}
              value={formData.cpf}
              onChange={handleChange}
              id={'cpf'}
              placeholder={'Informe o seu CPF'}
              textAlign="center"
              mascara="cpf"
              name={'cpf'}
            />
            <div className="d-grid mt-3 gap-3">
              <Button
                botaoAzul
                label={'Solicitar alteração'}
                onClick={handleSubmit}
              />
              <img
                src={ouImg}
                alt="Ou"
                style={{
                  display: 'flex',
                  maxWidth: '30%',
                  margin: '0 auto',
                }}
              />
              <Button
                botaoAmarelo
                label={'Retornar ao Login'}
                onClick={() => navigate('/')}
              />
            </div>
          </Stack>
        </Container>
      </ContainerBase>
    </motion.div>
  );
}

export default EsqueciSenha;
